import {footer, Footer} from "./footer/FooterComponent";
import {openTraderWelcomeWizard, OpenTraderWelcomeWizard} from "./wizard/open-trader/OpenTraderWelcomeWizardComponent";
import {
    openMarketsWelcomeWizard,
    OpenMarketsWelcomeWizard
} from "./wizard/open-markets/OpenMarketsWelcomeWizardComponent";
import {bellmontWelcomeWizard, BellmontWelcomeWizard} from "./wizard/bellmont/BellmontWelcomeWizardComponent";
import {
    futureAssistWelcomeWizard,
    FutureAssistWelcomeWizard
} from "./wizard/future-assist/FutureAssistWelcomeWizardComponent";
import {allfinWelcomeWizard, AllfinWelcomeWizard} from "./wizard/allfin/AllfinWelcomeWizardComponent";
import {waimakWelcomeWizard, WaimakWelcomeWizard} from "./wizard/waimak/WaimakWelcomeWizardComponent";
import {suubeeWelcomeWizard, SuubeeWelcomeWizard} from "./wizard/suubee/SuubeeWelcomeWizardComponent";
import {liquidityWelcomeWizard, LiquidityWelcomeWizard} from "./wizard/liquidity/LiquidityWelcomeWizardComponent";
import {fxeWelcomeWizard, FxeWelcomeWizard} from "./wizard/fxe-phillip/FxeWelcomeWizardComponent";

const rootDir = "app/layout";

export default angular.module("tfApp.layout", [])
                      .component(Footer, footer(rootDir))
                      .component(OpenTraderWelcomeWizard, openTraderWelcomeWizard())
                      .component(OpenMarketsWelcomeWizard, openMarketsWelcomeWizard())
                      .component(BellmontWelcomeWizard, bellmontWelcomeWizard())
                      .component(FutureAssistWelcomeWizard, futureAssistWelcomeWizard())
                      .component(AllfinWelcomeWizard, allfinWelcomeWizard())
                      .component(WaimakWelcomeWizard, waimakWelcomeWizard())
                      .component(SuubeeWelcomeWizard, suubeeWelcomeWizard())
                      .component(LiquidityWelcomeWizard, liquidityWelcomeWizard())
                      .component(FxeWelcomeWizard, fxeWelcomeWizard())
                      .name;
